/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Button, ButtonGroup, ButtonToolbar } from 'reactstrap'

import Select, { components } from 'react-select';

import {AppContext} from '../AppContext'

class VaultViewButtonBar extends React.Component
{
  sharedOptions = 
  [
    {option: 'All Shared Objects'},
    {option: 'Shared With Public'},
    {option: 'Shared With Me'}
  ];

  columnPickerChecked(event)
  {
    return;
  }

  constructor(props)
  {
    super();

    this.objectTypePickerChanged = this.objectTypePickerChanged.bind(this);
  }

  objectTypePickerChanged(selectedColumn)
  {
    this.props.objectTypePickerChanged(selectedColumn);
  }

  objectTypePickerChecked(event)
  {
    return;   // No-op...
  }

  render()
  {
    let objectTypePicker = this.renderObjectTypePicker();
    let columnPicker = this.renderColumnPicker();
    let sharedPicker = this.renderSharedPicker();

    return(
      <ButtonToolbar>
        <ButtonGroup size="sm">
          <Button style={{backgroundColor: 'transparent'}} title="Column Filters" onClick={this.props.toggleColumnFilters}><img src="assets/images/icons8-filter-24.png" alt="Column Filters" /></Button>
          <Button style={{backgroundColor: 'transparent'}} title="Toggle Selected Objects" onClick={this.props.toggleSelectedRows}><img src="assets/images/select_all.png" alt="Toggle Selected Objects" /></Button>
          <Button style={{backgroundColor: 'transparent'}} title="Refresh" onClick={this.props.refreshButtonHandler}><img src="assets/images/refresh.png" alt="Refresh" /></Button>
        { ('' !== this.context.appLocalStorage.getGatewayName() && 'uncataloged' === this.props.viewType &&
          <Button style={{backgroundColor: 'transparent'}} title="Enable/Disable Gateway" onClick={this.props.toggleGateway}><img src="assets/images/gate.png" alt="Toggle Gateway" /></Button>
        )} 
          <Button style={{backgroundColor: 'transparent'}} title="Keywords" onClick={this.props.keywordsButtonHandler}><img src="assets/images/key.png" alt="Keywords" /></Button>
        { ('cataloged' === this.props.viewType || 'uncataloged' === this.props.viewType) && this.context.userSession.shareObjectsEnabled(this.context.userUiProfile.grantedPermissions) &&
          <Button style={{backgroundColor: 'transparent'}} title="Sharing" onClick={this.props.sharingButtonHandler}><img src="assets/images/share.png" alt="Sharing" /></Button>
        }
        { ('deleted' !== this.props.viewType &&
          <Button style={{backgroundColor: 'transparent'}} title="Generate Weblink" onClick={this.props.secureWeblinkButtonHandler}><img src="assets/images/link.png" alt="Generate Weblink" /></Button>
        )}          
        { ('uncataloged' === this.props.viewType && '' !== this.context.appLocalStorage.getGatewayName() &&
          <Button style={{backgroundColor: 'transparent'}} title="Enroll File" onClick={this.props.enrollButtonHandler}><img src="assets/images/newFile.png" alt="Enroll File" /></Button>
        )}
        { ('cataloged' === this.props.viewType || 'uncataloged' === this.props.viewType) && window.extensionEnabled(this.context.websiteProfile.installedExtensions, this.context.extensions.AI) &&
          <>
            <Button style={{backgroundColor: 'transparent'}} title="Generate Vector Embeddings" onClick={this.props.generateEmbeddings}><img src="assets/images/vectorEmbedding.png" alt="Generate Embeddings" /></Button>
            <Button style={{backgroundColor: 'transparent'}} title="Chatbot Interface" onClick={this.props.openChatInterface}><img src="assets/images/chatbot.png" alt="Generate Embeddings" /></Button>
            <Button style={{backgroundColor: 'transparent'}} title="Image Search" onClick={this.props.imageSearch}><img src="assets/images/image-text.png" alt="Image Search" /></Button>
          </>
        }
          {objectTypePicker}
          {columnPicker}
          {sharedPicker}
        </ButtonGroup>
      </ButtonToolbar>
    );
  }

  renderColumnPicker()
  {
    const selectStyle =
    {
      control: (provided, state) => (
        {
          ...provided,
          width: 175
        }
      )
    }

    const Option = (props) =>
    {
      return (
        <div>
          <components.Option {...props}>
            <input checked={props.data.selected} type="checkbox" onChange={this.columnPickerChecked} />
            <span>&nbsp;{props.data.label}</span>            
          </components.Option>
        </div>
      );    
    };

    return (
      <Select multi={true} removeSelected={false} placeholder="Columns..." cache={false} className="create-component-select multi-select"
        options={this.props.columnPickerData} backspaceToRemoveMessage="remove" value={''}
        components={{ Option }} styles={selectStyle} closeMenuOnSelect={false} onChange={this.props.columnPickerChanged} 
      />            
    );   
  }

  renderObjectTypePicker()
  {
    const selectStyle =
    {
      control: (provided, state) => (
        {
          ...provided,
          width: 175
        }
      )
    }

    const Option = (props) =>
    {
      return (
        <div>
          <components.Option {...props}>
            <input checked={props.data.selected} type="checkbox" onChange={this.objectTypePickerChecked} />
            <span>&nbsp;{props.data.objectType}</span>            
          </components.Option>
        </div>
      );    
    };

    let value = undefined;
    if (undefined !== this.props.objectTypePickerData)
    {
      value = this.props.objectTypePickerData[0];
      if (!this.props.objectTypePickerData[0].selected)
      {
        for (let x = 0; x < this.props.objectTypePickerData.length; x++)
        {
          if (this.props.objectTypePickerData[x].selected)
          {
            value = this.props.objectTypePickerData[x];
            break;
          } 
        }
      }
    }

    return(
      <Select multi={true} removeSelected={false} placeholder={this.props.objectTypePlaceholder} cache={false} className="create-component-select multi-select"
        options={this.props.objectTypePickerData} backspaceToRemoveMessage="remove" value={value}
        closeMenuOnSelect={false} onChange={this.objectTypePickerChanged} getOptionValue={option => option.index}
        getOptionLabel={option => option.objectType} styles={selectStyle} components={{ Option }}
      />
    );
  }

  renderSharedPicker()
  {
    if ('shared' !== this.props.viewType) return false;

    const selectStyle =
    {
      control: (provided, state) => (
        {
          ...provided,
          width: 175
        }
      )
    }

    return(
      <Select multi={false} removeSelected={false} placeholder={'All Shared Objects'} cache={false}
        options={this.sharedOptions} value={this.props.sharedOption} closeMenuOnSelect={true} onChange={this.props.sharedOptionChanged}
        getOptionValue={option => option.option} getOptionLabel={option => option.option} styles={selectStyle} 
      />
    );
  }
}

VaultViewButtonBar.contextType = AppContext
export default VaultViewButtonBar
